import ResultForm from './ResulrForm.vue';

export * from './types';
export default ResultForm;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/resultform/index.ts